import React, { ComponentType, FunctionComponent } from 'react';

import { AuthInterface } from '../auth';
import { Environment } from '../types';
import { getRedirectUrl } from '../utils/redirect/redirectUrl';

type withCookieAuthenticatorOptions = {
  env: Environment;
};

const withCookieAuthenticator = <T extends object>(
  Component: ComponentType<T>,
  Auth: AuthInterface,
  options: withCookieAuthenticatorOptions
) => {
  const AppWithAuthenticator: FunctionComponent<T> = props => {
    const user = Auth.currentAuthenticatedUser();

    if (user == null) {
      const redirectUrl = getRedirectUrl(options.env, window.location.host);

      window.location.assign(redirectUrl);
      return null;
    }

    return <Component {...props} />;
  };

  return AppWithAuthenticator;
};

export default withCookieAuthenticator;
